import React from "react"

export default function LevelRight(props) {
  return (
    <div className={`level-right ${props.className}`}>{props.children}</div>
  )
}
